/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { collection, getDocs, query, where } from 'firebase/firestore'

import { firestore } from '../api/Firebase'

const extractTenantId = (tenant: unknown): string | null => {
  if (!tenant || typeof tenant !== 'object') {
    if (typeof tenant === 'string') {
      const trimmed = tenant.trim()
      if (!trimmed) return null
      return trimmed.split('/').filter(Boolean).pop() ?? null
    }
    return null
  }

  if ('id' in tenant && typeof tenant.id === 'string' && tenant.id.trim()) {
    return tenant.id.trim()
  }

  if (
    'path' in tenant &&
    typeof tenant.path === 'string' &&
    tenant.path.trim()
  ) {
    return tenant.path.split('/').filter(Boolean).pop() ?? null
  }

  return null
}

const getUserTenant = async (email: string): Promise<string | null> =>
  getDocs(
    query(collection(firestore, 'users'), where('email', '==', email)),
  ).then(
    snapshot =>
      snapshot.docs.map(doc => {
        const user = doc.data()
        return {
          id: doc.id,
          ...user,
          tenant: extractTenantId(user.tenant),
        }
      })[0]?.tenant || null,
  )

export const FirebaseHelpers = {
  getUserTenant,
}
